/** @fileoverview Shared paging controls for caller-owned result sets, keeping PrimeReact's `{ page, first, rows }` change event. Fetching and global record counts remain with the workspace. */
import React from 'react';
import AppButton from './AppButton';
import './AppControls.css';

export function Paginator({ first = 0, rows = 25, totalRecords = 0, rowsPerPageOptions, onPageChange, className = '' }) {
  const page = Math.floor(first / rows);
  const pages = Math.max(1, Math.ceil(totalRecords / rows));
  const change = (nextPage, nextRows = rows) => onPageChange?.({ page: nextPage, first: nextPage * nextRows, rows: nextRows, pageCount: Math.ceil(totalRecords / nextRows) });
  return <nav aria-label="Pagination" className={`app-paginator ${className}`}>
    <span>{totalRecords ? first + 1 : 0}–{Math.min(first + rows, totalRecords)} of {totalRecords}</span>
    {rowsPerPageOptions && <select aria-label="Rows per page" value={rows} onChange={event => change(0, Number(event.target.value))}>
      {rowsPerPageOptions.map(count => <option key={count} value={count}>{count}</option>)}
    </select>}
    <AppButton icon="pi pi-chevron-left" aria-label="Previous page" variant="secondary" disabled={page === 0} onClick={() => change(page - 1)} />
    <span>{page + 1} / {pages}</span>
    <AppButton icon="pi pi-chevron-right" aria-label="Next page" variant="secondary" disabled={page >= pages - 1} onClick={() => change(page + 1)} />
  </nav>;
}
export default Paginator;
